export function validateTime(value) {
  if (typeof value !== 'string') return false
  const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i
  return regex.test(value.trim())
}